import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { history } from "store"
import {isUndefined} from 'lodash'
import IntlMessages from 'util/IntlMessages';

const options = [
  <div className="d-block d-sm-none"><Link to="/app/Avtal"><IntlMessages id="Agreement"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Prospekt"><IntlMessages id="Prospectus"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Aktiviteter"><IntlMessages id="Activities"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Order"><IntlMessages id="Order"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Ärende"><IntlMessages id="Errand"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Projekt"><IntlMessages id="Project"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Dialer"><IntlMessages id="DashBoard.Dialer"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Offert"><IntlMessages id="Offer"/></Link></div>,
  <div className="d-block d-sm-none"><Link to="/app/Dashboard"><IntlMessages id="Dashboard"/></Link></div>,
  <div className=""><Link to="/app/Esignering"><IntlMessages id="E-signing"/></Link></div>,
  <div className=""><Link to="/app/Möte"><IntlMessages id="DashBoard.Customized.Booking"/></Link></div>,
  <div className=""><Link to="/app/nDrive"><IntlMessages id="nDrive"/></Link></div>,
  <div className=""><Link to="/app/Kunder"><IntlMessages id="Customers"/></Link></div>,
];




const ITEM_HEIGHT = 48;

export default function LongMenu(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const navData = [
    { value: '/app/Avtal', label: <IntlMessages id="Agreement"/>,isActive: isUndefined(props.Flags)?false:(props.Flags.Avtal ===1 )?true:false,classes:"d-md-none",func: props.getAvtalByUserid },
    { value: '/app/Prospekt', label: <IntlMessages id="Prospectus"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Prospekt ===1 )?true:false, classes:"d-md-none",func: props.getProspektByUserid },
    { value: '/app/Aktiviteter', label: <IntlMessages id="Activities"/>,isActive: isUndefined(props.Flags)?false:(props.Flags.Aktiviteter ===1 )?true:false,classes:"d-md-none",func: props.getAktiviByUserid },
    { value: '/app/Order', label: <IntlMessages id="Order"/>, isActive:isUndefined(props.Flags)?false:(props.Flags.OrderF ===1 )? (props.authUser.user_SeeOrderList === 0) ? false : true:false, func: props.getOrderByUserID,classes:"d-md-none"  },
    { value: '/app/Ärende', label: <IntlMessages id="Errand"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Arende ===1 )?(props.authUser.user_SeeCasesList === 0) ? false : true:false, func: props.getCasesByUserid,classes:"d-md-none"},
    { value: '/app/Projekt', label: <IntlMessages id="Project"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Projekt ===1 )?(props.authUser.user_SeeProjects === 0) ? false : true:false, func: props.getCasesByUserid,classes:"d-md-none"},
    { value: '/app/Dialer', label: <IntlMessages id="Dialer"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Dialer ===1 )?(props.authUser.user_SeeDialer === 0) ? false : true:false, func: props.getDialerByUserid,classes:"d-md-none"  },
    { value: '/app/Offert', label: <IntlMessages id="Offer"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Offert ===1 && props.Flags.Mallmodulen === 0)?true:false, func: props.getOffertByUserid,classes:"d-md-none" } ,
    { value: '/app/v2/Offert', label: <IntlMessages id="Offer"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Mallmodulen === 1 )?true:false, func: props.getOffertByUserid,classes:"d-md-none" } ,
    { value: '/app/Kunder', label: <IntlMessages id="Customers"/>, isActive: true, func: props.getKunderByUserid,classes:"d-md-none" } ,
    { value: '/app/Dashboard', label: <IntlMessages id="Dashboard"/>, isActive:isUndefined(props.Flags)?false: (props.Flags.Dashboard ===1 )?true:false, func: props.getDashByUserid,classes:"d-md-none" } ,
    { value: '/app/Esignering', label: <IntlMessages id="E-signing"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Esignering ===1 || props.Flags.GetAccept === 1 )?true:false, func: props.getEsingeringByUserid,classes:"" } ,
    { value: '/app/Möte', label: <IntlMessages id="Meeting"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.Kalender ===1 )?true:false, func: props.getMoteByUserid,classes:"" } ,
    { value: '/app/nDrive', label: <IntlMessages id="nDrive"/>, isActive:isUndefined(props.Flags)?false:(props.Flags.nDrive === 1 )?true:false, func: props.getFilerByUserid,classes:"" } ,
    { value: '/app/Kunddata', label: <IntlMessages id="Customer.Data"/>, isActive:isUndefined(props.Flags)?false:parseInt(props.Flags.Kunddata) === 1 ?true:false , func: props.getKundDataByAfid,classes:"" } ,
    { value: '/app/KedjaOrder', label: <IntlMessages id="Order"/>, isActive: isUndefined(props.Flags)?false:(props.Flags.IsKedja === 1 )?true:false, func: props.getOrderByKedja,classes:"" } ,
    /**/
];
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        variant="outlined"
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        className={"p-0"}
        style={{ minWidth:"auto",border:"0px" }}
      >
        <ExpandMoreOutlinedIcon />
      </Button>
      <Menu
        style={{position: 'absolute', top: 35}}
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            // maxHeight: ITEM_HEIGHT * 4.5,
            width: '20ch',
          },
        }}
      >
        {
        
        navData.map((option,index) => {
        if(option.isActive === true){
          return(    
            <MenuItem key={index} className={option.classes} onClick={() => {
              history.push(option.value)
              handleClose()
            }}>
                <div><Link to={option.value} onClick={option.func}>{option.label}</Link></div>
            </MenuItem>
            )
          }
        }
        )}
      </Menu>
    </>
  );
}